import ResetPasswordWithToken from '@shared/components/auth/ResetPasswordWithToken';
import * as Actions from '@/app/store/actions';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

const ResetPasswordWithLinkPage = () => {
	const dispatch = useDispatch();
	const location = useLocation();

	const handleSuccess = (message) => {
		dispatch(
			Actions.showMessage({
				message,
				variant: 'success',
				autoHideDuration: 3000,
			})
		);
	};

	const handleError = (message) => {
		dispatch(
			Actions.showMessage({
				message,
				variant: 'error',
				autoHideDuration: 3000,
			})
		);
	};

	return <ResetPasswordWithToken location={location} onError={handleError} onSuccess={handleSuccess} />;
};

export default ResetPasswordWithLinkPage;
